import { render } from "./WorkingGroupMembers.vue?vue&type=template&id=4b006e70&scoped=true"
import script from "./WorkingGroupMembers.vue?vue&type=script&lang=js"
export * from "./WorkingGroupMembers.vue?vue&type=script&lang=js"

import "./WorkingGroupMembers.vue?vue&type=style&index=0&id=4b006e70&scoped=true&lang=css"
import "./WorkingGroupMembers.vue?vue&type=style&index=1&id=4b006e70&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b006e70"]])

export default __exports__